import { Button } from '@bambi/component-library/src/components/Button/Button';
import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { DateTime } from 'luxon';
import { NavLink } from 'react-router';

import { useAppSelector } from 'src/app/store/hooks';
import { formatDateAsTodayOrMonthDay } from 'src/common/date/formatDateAsTodayOrMonthDay';
import { EmptyState } from 'src/common/primitives/EmptyState/EmptyState';
import { useDispatchRepository } from 'src/features/dispatch/common/useDispatchRepository';

export function AssignmentEmptyState() {
  const { isFetching: dispatchFetching } = useDispatchRepository();
  const selectedDate = useAppSelector((state) => state.dispatcher.selectedDate);
  const isFiltered = useAppSelector((state) => {
    const { drivers, driverTags, vehicleTags } =
      state.dispatcher.dispatchCalendarFilters;
    return (
      drivers.length > 0 || driverTags.length > 0 || vehicleTags.length > 0
    );
  });

  const now = DateTime.fromISO(DateTime.now().toISODate());
  const isDateInPast = DateTime.fromISO(selectedDate) < now;

  const generateDescription = () => {
    if (isDateInPast) {
      return '';
    }

    if (isFiltered) {
      return 'Please adjust your filters or add a new crew schedule';
    }

    return 'Please add a crew schedule to get started';
  };

  return (
    <div className="flex h-full items-center justify-center bg-gray-50">
      {dispatchFetching ? (
        <LoadingIndicator />
      ) : (
        <EmptyState
          Icon={<ExclamationCircleIcon className="h-6 w-6" />}
          entityName="Crew Schedules"
          Title={
            isFiltered
              ? 'No crew schedules match your filters'
              : `No crew schedules found for ${formatDateAsTodayOrMonthDay(
                  selectedDate
                )}`
          }
          description={generateDescription()}
          Action={
            <>
              {!isDateInPast && (
                <Button dataTestId="add-crew-schedule-button" variant="primary">
                  <NavLink to="/team">Add a Crew Schedule</NavLink>
                </Button>
              )}
            </>
          }
        />
      )}
    </div>
  );
}
